var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{attrs:{"src":_vm.appLogoImage,"alt":"logo","height":"28","width":"auto"}})}
var staticRenderFns = []

export { render, staticRenderFns }